import { PartialType, PickType } from '@nestjs/swagger';
import { JobPhasePhotoDto } from './job-phase-photo.dto';
import { JobPhasePhotoUpdatableInterface } from '../interfaces/job-phase-photo-updatable.interface';

export class JobPhasePhotoUpdateDto
  extends PartialType(PickType(JobPhasePhotoDto, ['fileName', 'metaData']))
  implements JobPhasePhotoUpdatableInterface {}
